export const DATA_FLIP_ID = 'data-flip-id'
export const DATA_INVERSE_FLIP_ID = 'data-inverse-flip-id'
export const DATA_FLIP_COMPONENT_ID = 'data-flip-component-id'
export const DATA_FLIP_CONFIG = 'data-flip-config'
export const DATA_PORTAL_KEY = 'data-portal-key'
export const DATA_EXIT_CONTAINER = 'data-exit-container'
export const DATA_IS_APPEARING = 'data-is-appearing'
